
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"flexibleInlineNavigationItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"flexibleSection_inlineNavigationItem_BlockType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anchor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"children"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleRichtext"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleImage"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleTextImage"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleCallToAction"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleVideo"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleAccordion"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleQuote"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleEditionsSchedule"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleTextCtaImage"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"flexibleTrainers"},"directives":[]}]}}]}}],"loc":{"start":0,"end":832}};
    doc.loc.source = {"body":"#import \"./flexibleRichtext.graphql\"\n#import \"./flexibleImage.graphql\"\n#import \"./flexibleTextImage.graphql\"\n#import \"./flexibleCallToAction.graphql\"\n#import \"./flexibleVideo.graphql\"\n#import \"./flexibleAccordion.graphql\"\n#import \"./flexibleQuote.graphql\"\n#import \"./flexibleEditionsSchedule.graphql\"\n#import \"./flexibleTextCtaImage.graphql\"\n#import \"./flexibleTrainers.graphql\"\n\nfragment flexibleInlineNavigationItem on flexibleSection_inlineNavigationItem_BlockType {\n    label\n    anchor\n    children {\n        __typename\n        ... flexibleRichtext\n        ... flexibleImage\n        ... flexibleTextImage\n        ... flexibleCallToAction\n        ... flexibleVideo\n        ... flexibleAccordion\n        ... flexibleQuote\n        ... flexibleEditionsSchedule\n        ... flexibleTextCtaImage\n        ... flexibleTrainers\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./flexibleRichtext.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./flexibleImage.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./flexibleTextImage.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./flexibleCallToAction.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./flexibleVideo.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./flexibleAccordion.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./flexibleQuote.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./flexibleEditionsSchedule.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./flexibleTextCtaImage.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./flexibleTrainers.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["flexibleInlineNavigationItem"] = oneQuery(doc, "flexibleInlineNavigationItem");
        
